import "core-js/modules/es.array.push.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.json.stringify.js";
import { toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode } from "vue";
const _hoisted_1 = {
  class: "deal-widget-container"
};
const _hoisted_2 = {
  class: "widget-list"
};
const _hoisted_3 = ["onClick"];
const _hoisted_4 = {
  class: "widget-item-image"
};
const _hoisted_5 = {
  alt: ""
};
const _hoisted_6 = {
  key: 0,
  class: "badge-tag",
  src: "https://m.media-amazon.com/images/G/28/NewApp/00_EN/CBadge_NY_Tips_English.gif",
  alt: ""
};
const _hoisted_7 = {
  class: "dotd-price"
};
const _hoisted_8 = {
  class: "price-area"
};
const _hoisted_9 = {
  class: "dotd-tag"
};
const _hoisted_10 = {
  key: 0
};
const _hoisted_11 = {
  key: 1
};
const _hoisted_12 = {
  class: "price"
};
const _hoisted_13 = {
  class: "price-suffix"
};
const _hoisted_14 = {
  class: "widget-item-title"
};
const _hoisted_15 = ["src"];
const _hoisted_16 = {
  key: 1,
  class: "widget-swiper-list"
};
const _hoisted_17 = {
  class: "widget-item"
};
const _hoisted_18 = {
  class: "widget-item-image"
};
const _hoisted_19 = {
  alt: ""
};
const _hoisted_20 = ["src"];
const _hoisted_21 = {
  class: "dotd-price"
};
const _hoisted_22 = {
  class: "price-area"
};
const _hoisted_23 = {
  class: "dotd-tag"
};
const _hoisted_24 = {
  key: 0
};
const _hoisted_25 = {
  key: 1
};
const _hoisted_26 = {
  class: "price"
};
const _hoisted_27 = {
  class: "price-suffix"
};
const _hoisted_28 = {
  class: "widget-item-title"
};
const _hoisted_29 = {
  key: 0,
  class: "swiper-right-tips"
};
const _hoisted_30 = ["src"];
import { ref, watch, nextTick, onMounted, onActivated } from 'vue';
import 'swiper/css/scrollbar';
import { Scrollbar } from 'swiper';
import constants from '@/constants';
import { useRoute, useRouter } from 'vue-router';
import { useLess } from '@/models/hooks';
import { DISPLAY_MODE, LAYOUT_TYPE, TEXT_BOLD_TYPE } from '@/configs/views/landingPage.js';
import { Swiper, SwiperSlide } from 'swiper/vue';
import CountDown from '@/components/countDown/CountDown.vue';
import { jumpInteractionType } from '@/utils/common';
import { awsRumHandler } from '@/utils/awsRumHandler.js';
import { getDealsByIdList } from '@/models/api/landingPageApi';
import { clickEvents } from '@/configs/awsRumConfig';
const paginationCount = 10;
export default {
  __name: 'DealWidget',
  props: {
    properties: {
      require: true,
      default: () => ({})
    }
  },
  setup(__props) {
    const props = __props;
    useLess('views/landingPage/dealWidget/DealWidget.less');
    const {
      IMAGE_URL,
      REF_MARKER_ABBR
    } = constants;
    const swiperModules = [Scrollbar];
    const MORE_IS_SHOW_TYPE = {
      HIDE: 'HIDE',
      // hide
      DISPLAY: 'DISPLAY' // show
    };

    const route = useRoute();
    const router = useRouter();
    const dealInfoList = ref([]);
    // swiperItem Dom
    const widgetSwiperItem = ref(null);
    const swiperRef = ref(null);

    // Style of configured elements
    const dealWidgetStyleObject = ref({});
    const masterTitleStyleObject = ref({});
    const deputyTitleStyleObject = ref({});
    // Do you want to display tips for the swiper
    const isShowSwiperTips = ref(false);

    // Rolling Load Related attribute
    const isDealInfoListLoading = ref(false);
    const isDealInfoListLoadingFinished = ref(false);
    let currentPage = 0;
    // Show tips when the slide swiper scrolls to the last page
    const switchShowSwiperTipsStatus = swiper => {
      if (swiper.activeIndex === dealInfoList.value.length - 2) {
        isShowSwiperTips.value = true;
      } else {
        isShowSwiperTips.value = false;
      }
    };
    const goToCustomTextContentPage = () => {
      jumpInteractionType(props.properties.interactionTypeInfo[0], router);
    };
    const swiperDomTouchLogic = () => {
      nextTick(() => {
        if (!widgetSwiperItem.value) {
          return;
        }
        // get swiper-item DOM list
        const swiperDomList = widgetSwiperItem.value[widgetSwiperItem.value.length - 1].swiperRef.value.slides;
        // get swiper-item last DOM
        const lastSwiperDom = swiperDomList[swiperDomList.length - 1];
        let startCilentX = 0;
        let endCilentX = 0;
        lastSwiperDom.addEventListener('touchstart', params => {
          startCilentX = params.touches[0].clientX;
        });
        // If the distance of the last element sliding is greater than 150, jump to the custom page
        lastSwiperDom.addEventListener('touchend', params => {
          endCilentX = params.changedTouches[0].clientX;
          if (endCilentX + 150 < startCilentX) {
            goToCustomTextContentPage();
          }
        });
      });
    };

    // get deal data
    const getDealListData = async dealIdList => {
      const res = await getDealsByIdList(dealIdList)['catch'](() => ({
        data: {
          deals: []
        }
      }));
      const deals = res.data.deals;
      deals === null || deals === void 0 ? void 0 : deals.forEach(dealItem => {
        dealItem.activityEndTime = dealItem.endTime - new Date().getTime();
      });
      dealInfoList.value.push(...res.data.deals);
    };
    const loadNextPage = async () => {
      // if dealIds empty not request
      if (!props.properties.dealIds || !props.properties.dealIds.length || dealInfoList.value.length >= props.properties.displayQuantity) {
        isDealInfoListLoadingFinished.value = true;
        isDealInfoListLoading.value = false;
        return;
      }
      const dealIdList = [];
      if (props.properties.layoutType === DISPLAY_MODE.NORMAL) {
        dealIdList.push(...props.properties.dealIds);
        isDealInfoListLoadingFinished.value = true;
      } else {
        // If displayQuantity is equal to 0, scroll load all deal data
        if (currentPage * paginationCount >= props.properties.dealIds.length) {
          isDealInfoListLoadingFinished.value = true;
          isDealInfoListLoading.value = false;
          return;
        }
        const dealIdsCopy = JSON.parse(JSON.stringify(props.properties.dealIds));
        dealIdList.push(...dealIdsCopy.slice(currentPage * paginationCount, (currentPage + 1) * paginationCount));
        currentPage += 1;
      }
      await getDealListData(dealIdList);
      isDealInfoListLoading.value = false;
    };
    const onGoToAsinList = dealItem => {
      router.push({
        name: 'asinList',
        params: {
          dealId: dealItem.id,
          dealTitle: dealItem.title,
          pageTitle: dealItem.type === REF_MARKER_ABBR.DEAL_OF_THE_DAY ? 'common.DOTD' : 'common.BEST_DEAL',
          dealEndTime: dealItem.endTime
        }
      });
    };
    const countDownFinish = dealItemId => {
      const findIndex = dealInfoList.value.findIndex(dealItem => dealItem.id === dealItemId);
      dealInfoList.value[findIndex].type = null;
    };
    const onSwiper = swiper => {
      swiperRef.value = swiper;
    };
    watch(() => props.properties, async data => {
      /*
       * Set Configuration Style
       */
      let dealIds = data.dealIds;
      dealWidgetStyleObject.value = {
        paddingBottom: `${data.bottomSpacing || 0}px`
      };
      masterTitleStyleObject.value = {
        fontSize: `${data.masterTextSize}px`,
        color: data.masterColor,
        fontWeight: TEXT_BOLD_TYPE[data.masterBoldType]
      };
      deputyTitleStyleObject.value = {
        fontSize: `${data.deputyTextSize}px`,
        color: data.deputyColor,
        fontWeight: TEXT_BOLD_TYPE[data.deputyBoldType]
      };
      if (data.layoutType === DISPLAY_MODE.WATERFALL) {
        dealIds = data.dealIds.slice(currentPage * paginationCount, (currentPage + 1) * paginationCount);
        currentPage += 1;
      }
      await getDealListData(dealIds);
      if (data.showType === LAYOUT_TYPE.HORIZONTAL) {
        swiperDomTouchLogic();
      }
    }, {
      immediate: true
    });
    onMounted(() => {
      const recordParams = {
        pageName: route.name
      };
      awsRumHandler.recordClickEvent({
        ...clickEvents.landingPage.dealWidgetWidget,
        ...recordParams
      });
    });
    onActivated(() => {
      var _swiperRef$value, _swiperRef$value$scro, _swiperRef$value$scro2;
      (_swiperRef$value = swiperRef.value) === null || _swiperRef$value === void 0 ? void 0 : (_swiperRef$value$scro = _swiperRef$value.scrollbar) === null || _swiperRef$value$scro === void 0 ? void 0 : (_swiperRef$value$scro2 = _swiperRef$value$scro.updateSize) === null || _swiperRef$value$scro2 === void 0 ? void 0 : _swiperRef$value$scro2.call(_swiperRef$value$scro);
    });
    return (_ctx, _cache) => {
      var _dealInfoList$value;
      const _component_van_list = _resolveComponent("van-list");
      const _directive_lazy = _resolveDirective("lazy");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [(_dealInfoList$value = dealInfoList.value) !== null && _dealInfoList$value !== void 0 && _dealInfoList$value.length ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "deal-widget",
        style: _normalizeStyle(dealWidgetStyleObject.value)
      }, [_createElementVNode("p", {
        class: "widget-title",
        style: _normalizeStyle(masterTitleStyleObject.value)
      }, _toDisplayString(__props.properties.masterTitle), 5), _createElementVNode("p", {
        class: "widget-sub-title",
        style: _normalizeStyle(deputyTitleStyleObject.value)
      }, _toDisplayString(__props.properties.deputyTitle), 5), __props.properties.showType === _unref(LAYOUT_TYPE).TWO_COLUMN ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 0
      }, [_createVNode(_component_van_list, {
        loading: isDealInfoListLoading.value,
        "onUpdate:loading": _cache[0] || (_cache[0] = $event => isDealInfoListLoading.value = $event),
        finished: isDealInfoListLoadingFinished.value,
        "loading-text": _ctx.$t('modules.commonComponent.pullRefresh.LOADING'),
        onLoad: loadNextPage
      }, {
        default: _withCtx(() => [_createElementVNode("ul", _hoisted_2, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dealInfoList.value, (dealItem, index) => {
          var _props$properties;
          return _openBlock(), _createElementBlock("li", {
            class: _normalizeClass(["widget-item", {
              'item-odd': index % 2 === 0
            }]),
            key: dealItem.id,
            onClick: $event => onGoToAsinList(dealItem)
          }, [_createElementVNode("div", _hoisted_4, [_withDirectives(_createElementVNode("img", _hoisted_5, null, 512), [[_directive_lazy, dealItem.imageUrl]]), (_props$properties = __props.properties) !== null && _props$properties !== void 0 && _props$properties.cornerIcon ? (_openBlock(), _createElementBlock("img", _hoisted_6)) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, [dealItem.type === _unref(REF_MARKER_ABBR).DEAL_OF_THE_DAY ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(_ctx.$t('common.DOTD')), 1)) : dealItem.type === _unref(REF_MARKER_ABBR).BEST_DEAL ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(_ctx.$t('common.BEST_DEAL')), 1)) : _createCommentVNode("", true)]), _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.$t('common.currencyUnit') + dealItem.price.amount), 1), _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.$t('common.TIME_REMAINING')) + " ", 1), dealItem.type ? (_openBlock(), _createBlock(CountDown, {
            key: 0,
            time: dealItem.activityEndTime,
            onFinish: $event => countDownFinish(dealItem.id)
          }, null, 8, ["time", "onFinish"])) : _createCommentVNode("", true)])]), _createElementVNode("p", _hoisted_14, _toDisplayString(dealItem.title), 1)], 10, _hoisted_3);
        }), 128))])]),
        _: 1
      }, 8, ["loading", "finished", "loading-text"]), __props.properties.moreIsShow === MORE_IS_SHOW_TYPE.DISPLAY && __props.properties.displayQuantity ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "click-see-more",
        onClick: goToCustomTextContentPage
      }, [_createTextVNode(_toDisplayString(__props.properties.customTextContent) + " ", 1), _createElementVNode("img", {
        src: `${_unref(IMAGE_URL)}assets/image/icons/rightArrowGrey.png`,
        alt: ""
      }, null, 8, _hoisted_15)])) : _createCommentVNode("", true)], 64)) : __props.properties.showType === _unref(LAYOUT_TYPE).HORIZONTAL ? (_openBlock(), _createElementBlock("div", _hoisted_16, [_createVNode(_unref(Swiper), {
        modules: swiperModules,
        ref_key: "swiperRef",
        ref: swiperRef,
        onSwiper: onSwiper,
        class: "widget-swiper",
        "slides-per-view": "auto",
        onTransitionEnd: switchShowSwiperTipsStatus,
        scrollbar: {
          hide: false
        }
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dealInfoList.value, (dealItem, index) => {
          return _openBlock(), _createBlock(_unref(SwiperSlide), {
            class: "swiper-slide-item",
            key: dealItem.id,
            ref_for: true,
            ref_key: "widgetSwiperItem",
            ref: widgetSwiperItem,
            onClick: $event => onGoToAsinList(dealItem)
          }, {
            default: _withCtx(() => {
              var _props$properties2, _props$properties3;
              return [_createElementVNode("div", _hoisted_17, [_createElementVNode("div", _hoisted_18, [_withDirectives(_createElementVNode("img", _hoisted_19, null, 512), [[_directive_lazy, dealItem.imageUrl]]), (_props$properties2 = __props.properties) !== null && _props$properties2 !== void 0 && _props$properties2.cornerIcon ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                class: "badge-tag",
                src: (_props$properties3 = __props.properties) === null || _props$properties3 === void 0 ? void 0 : _props$properties3.cornerIcon,
                alt: ""
              }, null, 8, _hoisted_20)) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_21, [_createElementVNode("div", _hoisted_22, [_createElementVNode("div", _hoisted_23, [dealItem.type === _unref(REF_MARKER_ABBR).DEAL_OF_THE_DAY ? (_openBlock(), _createElementBlock("span", _hoisted_24, _toDisplayString(_ctx.$t('common.DOTD')), 1)) : dealItem.type === _unref(REF_MARKER_ABBR).BEST_DEAL ? (_openBlock(), _createElementBlock("span", _hoisted_25, _toDisplayString(_ctx.$t('common.BEST_DEAL')), 1)) : _createCommentVNode("", true)]), _createElementVNode("span", _hoisted_26, _toDisplayString(_ctx.$t('common.currencyUnit') + dealItem.price.amount), 1), _createElementVNode("span", _hoisted_27, _toDisplayString(_ctx.$t('common.TIME_REMAINING')), 1)]), dealItem.type ? (_openBlock(), _createBlock(CountDown, {
                key: 0,
                time: dealItem.activityEndTime,
                onFinish: $event => countDownFinish(dealItem.id)
              }, null, 8, ["time", "onFinish"])) : _createCommentVNode("", true)]), _createElementVNode("p", _hoisted_28, _toDisplayString(dealItem.title), 1)]), __props.properties.moreIsShow === MORE_IS_SHOW_TYPE.DISPLAY && dealInfoList.value.length > 1 && index === dealInfoList.value.length - 1 ? (_openBlock(), _createElementBlock("div", _hoisted_29, [_createElementVNode("img", {
                src: `${_unref(IMAGE_URL)}assets/image/icons/leftArrowBorder.png`,
                alt: ""
              }, null, 8, _hoisted_30), _createElementVNode("span", null, _toDisplayString(__props.properties.customTextContent), 1)])) : _createCommentVNode("", true)];
            }),
            _: 2
          }, 1032, ["onClick"]);
        }), 128))]),
        _: 1
      }, 512)])) : _createCommentVNode("", true)], 4)) : _createCommentVNode("", true)]);
    };
  }
};